// extracted by mini-css-extract-plugin
export var container = "_5c-0";
export var icon = "_5c-1";
export var text = "_5c-2";